import { deleteData, getData, postData, postFormData } from './config/ApiCalls';

import { apiSettings } from '../Settings';

export const sendMessage = async (data) => {
  try {
    const response = await postData(
      `${apiSettings.message.sendMessage()}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getChatFor = async (data) => {
  try {
    const response = await postData(`${apiSettings.message.getChatFor}`, data);
    return response;
  } catch (error) {
    return null;
  }
};

export const getAllMessagesByTenderId = async (id = '') => {
  try {
    const response = await getData(
      `${apiSettings.message.getAllMessagesByTenderId(id)}`
    );
    return response;
  } catch (error) {
    return null;
  }
};
export const getChatHeads = async () => {
  try {
    const response = await getData(`${apiSettings.message.getChatHeads()}`);
    return response;
  } catch (error) {
    return null;
  }
};
